let cache = {}

export function getMetaContent(name) {
  if (!(`${name}` in cache)) {
    cache[name] = ''

    const element = document.querySelector(`meta[name="${name}"]`)
    if (element) {
      cache[name] = element.getAttribute('content')
    }
  }

  return cache[name]
}

export const getEnv = () => getMetaContent('x-env:environment')
export const getBaseUrlApi = () => getMetaContent('x-env:base-url-api')
export const getGoogleApiKey = () => getMetaContent('x-env:google-api-key')
export const getGoogleAnalyticsCode = () => getMetaContent('x-env:google-analytics-code')
